import * as events from '../base/constant';
import { ToolbarStatus } from '../../editor-manager/plugin/toolbar-status';
import { getDefaultHtmlTbStatus } from '../../common/util';
/**
 * HtmlToolbarStatus module for refresh the toolbar status
 */
export class HtmlToolbarStatus {
    constructor(parent) {
        this.debounceDelay = 100;
        this.parent = parent;
        this.toolbarStatus = this.prevToolbarStatus = getDefaultHtmlTbStatus();
        this.debounceDelay = this.debounceDelay !== undefined ? this.debounceDelay : 100;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.on(events.toolbarRefresh, this.onRefreshHandler, this);
        this.parent.on(events.destroy, this.removeEventListener, this);
    }
    removeEventListener() {
        this.toolbarStatus = null;
        this.prevToolbarStatus = null;
        this.debounceTimer = null;
        this.parent.off(events.toolbarRefresh, this.onRefreshHandler);
        this.parent.off(events.destroy, this.removeEventListener);
    }
    onRefreshHandler(args) {
        if (this.parent.readonly) {
            return;
        }
        // extract the 'event' property from args only if it exists and is an instance of Event
        const event = !!(args['args'] && args['args'].isKeyboardEvent);
        // If KeyboardEvent, debounce; else process immediately
        if (event && !(this.parent.element &&
            this.parent.element.dataset &&
            this.parent.element.dataset.rteUnitTesting === 'true')) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = window.setTimeout(() => {
                this.getToolbarStatus(args);
            }, this.debounceDelay);
        }
        else {
            clearTimeout(this.debounceTimer);
            this.getToolbarStatus(args);
        }
    }
    // method for getting toolbar status:
    getToolbarStatus(args) {
        const fontsize = [];
        const fontName = [];
        const formats = [];
        this.parent.fontSize.items.forEach((item) => {
            fontsize.push(item.value);
        });
        this.parent.fontFamily.items.forEach((item) => {
            fontName.push(item.value);
        });
        this.parent.format.types.forEach((item) => {
            formats.push(item.value.toLocaleLowerCase());
        });
        this.toolbarStatus = ToolbarStatus.get(this.parent.contentModule.getDocument(), this.parent.contentModule.getEditPanel(), formats, fontsize, fontName, args.documentNode);
        const tbStatusString = JSON.stringify(this.toolbarStatus);
        this.parent.notify(events.toolbarUpdated, this.toolbarStatus);
        if (JSON.stringify(this.prevToolbarStatus) !== tbStatusString) {
            this.parent.notify(events.updateTbItemsStatus, { html: JSON.parse(tbStatusString), markdown: null });
            this.prevToolbarStatus = JSON.parse(tbStatusString);
        }
    }
}
